import { Guid } from '@web/utils';
import { ShippingMethodCode } from '@web/shared/module/shop';
import { DictionaryCountry } from '@web/shared/module/dictionary';

export class AdminShippingMethodCollectionItem {
  public constructor(
    private readonly data: {
      canBeEdited: boolean;
      canBeViewed: boolean;
      code: ShippingMethodCode;
      createdAt: Date;
      description: string;
      id: Guid;
      name: string;
      countries: DictionaryCountry[];
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get name(): string {
    return this.data.name;
  }

  public get canBeViewed(): boolean {
    return this.data.canBeViewed;
  }

  public get canBeEdited(): boolean {
    return this.data.canBeEdited;
  }

  public get code(): ShippingMethodCode {
    return this.data.code;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get description(): string {
    return this.data.description;
  }

  public get countries(): DictionaryCountry[] {
    return this.data.countries;
  }
}
